import { render, staticRenderFns } from "./media_nota_por_disciplina.vue?vue&type=template&id=245661d1&scoped=true&"
import script from "./media_nota_por_disciplina.vue?vue&type=script&lang=js&"
export * from "./media_nota_por_disciplina.vue?vue&type=script&lang=js&"
import style0 from "./media_nota_por_disciplina.vue?vue&type=style&index=0&id=245661d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245661d1",
  null
  
)

export default component.exports